module.exports = __webpack_public_path__ + "img/mx.5861fa14.png";